import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "segment-wrapper",
  id: "segment-container",
  ref: "translationSegment"
}
const _hoisted_2 = {
  class: "number",
  id: "row-number"
}
const _hoisted_3 = { class: "text-group" }
const _hoisted_4 = { class: "source-target" }
const _hoisted_5 = {
  class: "source-text",
  id: "source-container"
}
const _hoisted_6 = { class: "next-segment-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StyleBadge = _resolveComponent("StyleBadge")!
  const _component_SourceSegment = _resolveComponent("SourceSegment")!
  const _component_TargetEditorClearable = _resolveComponent("TargetEditorClearable")!
  const _component_TranslationVariantsPopup = _resolveComponent("TranslationVariantsPopup")!
  const _component_SegmentControls = _resolveComponent("SegmentControls")!
  const _component_FindNextSegment = _resolveComponent("FindNextSegment")!
  const _component_MergeButton = _resolveComponent("MergeButton")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass([{'focused-row': _ctx.segmentItem.focused}, 'segment-box'])
    }, [
      _createVNode(_component_StyleBadge, {
        stylesApplied: _ctx.translationSegment.stylesApplied,
        styleName: _ctx.translationSegment.paragraphStyleName
      }, null, 8, ["stylesApplied", "styleName"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.segmentItem.rowNumber), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_SourceSegment, {
              modelValue: _ctx.translationSegment.sourceData,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.translationSegment.sourceData) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_TargetEditorClearable, {
            modelValue: _ctx.segmentItem,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.segmentItem) = $event)),
            disableFormatting: _ctx.isIdmlDocument
          }, null, 8, ["modelValue", "disableFormatting"])
        ]),
        _createVNode(_component_TranslationVariantsPopup, {
          modelValue: _ctx.segmentItem,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.segmentItem) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_SegmentControls, {
        modelValue: _ctx.segmentItem,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.segmentItem) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FindNextSegment, {
          focused: _ctx.segmentItem.focused,
          translationLoadded: _ctx.isTranslationLoaded,
          onNextTranslateSegment: _ctx.handleNextSegment
        }, null, 8, ["focused", "translationLoadded", "onNextTranslateSegment"])
      ])
    ], 2)), [
      [_directive_loading, _ctx.segmentItem.loading]
    ]),
    _createVNode(_component_MergeButton, {
      class: _normalizeClass([{ show: _ctx.showMergeButton }, 'hidden']),
      focused: _ctx.segmentItem.focused,
      disabled: _ctx.mergeDisabled,
      documentType: _ctx.currentDocumentType,
      onMerge: _ctx.handleMerge
    }, null, 8, ["class", "focused", "disabled", "documentType", "onMerge"]),
    (_ctx.splitPossible)
      ? (_openBlock(), _createBlock(_component_SplitButton, {
          key: 0,
          focused: _ctx.segmentItem.focused,
          onSplit: _ctx.handleSplit
        }, null, 8, ["focused", "onSplit"]))
      : _createCommentVNode("", true)
  ], 512))
}